// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-document-usage-list .expanded-cell-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/document-template/document-template-confirm-delete-dialog/document-usage-list/document-usage-list.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAAR","sourcesContent":[".fi-document-usage-list {\r\n    .expanded-cell-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 10px;\r\n        \r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
